export const templateMigrationNotification = {
    text: 'notification-migrate-templates',
    linkText: 'notification-migrate-templates-link',
    link: 'mailto:help.scf@siemens.com'
};
